import React from 'react';
import { PriorityBanner, Navbar } from '../components';

interface MainLayoutProps {
  children: React.ReactNode;
}

export const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  return (
    <div className="font-primary min-h-screen text-neutral-900">
      <PriorityBanner />
      <Navbar />
      <main className="relative">{children}</main>
    </div>
  );
};
